export const USER_ROLES = [
  { value: "client", label: "Client", description: "Acesso às informações como perfil e visualização de dashboard" },
  { value: "bi", label: "BI", description: "Acesso a criações, edição e exclusão de usuários, grupos e dashboards" },
  { value: "sales", label: "Sales", description: "Pode gerar propostas e editá-las" },
  { value: "salesAdmin", label: "Sales Admin", description: "Acesso à edição das configurações de propostas" },
  { value: "masterAdmin", label: "Master Admin", description: "Acesso total ao sistema como dono" }
];
